<template>

  <div class="Psychological_archives">
    <transit :users="UserID" />
    <div>
      <div style="margin-top: 10px;margin-left: 2%;">
        <!-- <el-button type="primary">危机台账</el-button> -->
        <!-- <el-button type="primary" @click="gourl()">谈话记录</el-button> -->
        <!-- <el-button type="primary" style="margin-right: 40px;">多方会谈</el-button> -->
        上报类型：
        <el-select size="medium" v-model="Type" placeholder="请选择上报类型" @change="type_switching()">
          <el-option label="全部" value=""></el-option>
          <el-option label="谈话记录" value="2"></el-option>
          <el-option label="多方会谈" value="3"></el-option>
        </el-select>
      </div>
      <el-table :data="tableData" stripe style="width: 96%;margin-left: 2%;margin-top: 20px;">
        <el-table-column  prop="RecordName"     label="上报人"  width="180"></el-table-column>
        <el-table-column  prop="ReportTime"     label="上报时间"  width="180"></el-table-column>
        <el-table-column  prop="Type"  label="上报类型"></el-table-column>
        <el-table-column  prop="UrgentStatus"  label="危机状态"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span v-if="scope.row.Type == '谈话记录'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_view(scope.row.TalkNo)">查看详情</span>
            <span v-else-if="scope.row.Type == '多方会商'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="$router.push('/Crisis/Multiparty?KeyNo='+scope.row.MTalk+'&num=1')">查看多方会商</span>
            <span v-else style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看详情</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange1" :current-page.sync="pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Count"></el-pagination>

    </div>


  </div>
</template>

<script>
import transit from './transit'
export default {
  data(){
    return {
      tableData: [],
      pageIndex: 1,
      Type: '',
      Count: 0,
      UserID: '',
    }
  },
  components: {
    transit,
  },
  methods: {
    gourl() {
      this.$router.push({
        path: '/Crisis/Memcon',
      })
    },
    Crisis_lookprefabrication(KeyNo, reportStatus, userId) {//查看预制表
      this.$router.push({
        path: '/Crisis/Crisis_lookprefabrication',
        query: { KeyNo: KeyNo, reportStatus: reportStatus, userId: userId },
      })
    },
    Crisis_Memcon_view(TalkNo) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_view',
        query: { TalkNo: TalkNo },
      });
    },
    type_switching() {//类型切换
      this.load();
    },
    handleCurrentChange1(val) {
      this.pageIndex1 = val;
      this.load();
    },
    load(form) {//列表
      this.$Http_Post('DistressPrediction/StuCrisisIntervene', {PageIndex: this.pageIndex, PageSize: 10, UserID: this.UserID, Type: this.Type}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Count = Number(res.Counts);
        }
      })
    },
  },
  mounted() {
    this.UserID = [this.$route.query.UserID][0];
    this.load();
  }
}
</script>
<style>
  .Psychological_archives{width: 100%;height: 100%;background-color: #fff;}
  .el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>